import React from "react";

export default function Header() {
  return (
    <header className="app-header">
      <p>Drag each muscle name and drop it in it’s correct place.</p>
    </header>
  );
}
